export const ICON_STROKE = 1.25;
